import React, { useCallback, useEffect, useState } from 'react'
import { useTheme } from '@mui/material/styles';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import PushPinIcon from '@mui/icons-material/PushPin';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Checkbox, Divider, Grid, IconButton, TextField, Typography } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import Chip from '@mui/material/Chip';
import { createNotation, updateNotation } from '../../../../actions/notation.js';

import {notation_custoquestion_all} from '../../../../bdd/bddSTUB.js'
import { isFeuilleDeMatchFull } from '../../utils/feuilleMatch.js';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import MultiSelectTags from '../helpers/MultiSelectTags.js';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }

const defaultData = {
  customQuestion : '', 
  globalTarget : '', 
  preciseTarget : '', 
  exactTarget : [], 
  isPin : false,

  tags : []
}

const LiveNotation = ({match, onSubmit, type, initial = defaultData, isEditing = false}) => {
    const theme = useTheme();

    const dispatch = useDispatch()

    const [globalTarget, setGlobalTarget] = useState(initial.globalTarget)

    const [preciseTarget, setPreciseTarget] = useState(initial.preciseTarget)

    const [exactTarget, setExactTarget] = useState(initial.exactTarget)

    const [customQuestion, setCustomQuestion] = useState(initial.customQuestion)

    const [isPin, setIsPin] = useState(initial.isPin)

    const [displayDate, setDisplayDate] = useState(initial.displayDate)

    const [questionError, setQuestionError] = useState(false);

    const [tags, setTags] = useState(initial.tags || []);

    const [isEditMode, setIsEditMode] = useState(false);

    useEffect(() => {
      if(isEditing){
        let selectedQuestion = notation_custoquestion_all.find(c => c._id === customQuestion)

        if(selectedQuestion){
          setIsEditMode(false);
        }else{
          setIsEditMode(true);
        }
      }

    }, [])

    useEffect(() => {
      // Si dans articleData.tags on a un ID qui n'est plus dans match.tags, on le retire de articleData
      const newTags = tags ? tags.filter(t => match.tags.find(tag => tag._id === t)) : []
  
      setTags(newTags)
  
    }, [match.tags])

    const targetList = useCallback(() => {
        if(!globalTarget || globalTarget==='match')
            return []
        else{
          
            if(globalTarget===match.homeTeam._id){
                // On retourne la liste des joueurs de l'équipe
                if(isFeuilleDeMatchFull(match))
                  return match.homeHolders.concat(match.homeSubstitutes)
                else
                  return match.homeTeam.players
            }else{
                if(isFeuilleDeMatchFull(match))
                  return match.awayHolders.concat(match.awaySubstitutes)
                else
                  return match.awayTeam.players
            }
        }
    }, [globalTarget])

    const isValidForm = useCallback(() => {
      return globalTarget==="match" || preciseTarget==="team" || exactTarget.length>0

    }, [globalTarget, preciseTarget, exactTarget])

    const onChangeDisplayDate = (newDate) => {
     setDisplayDate(newDate);
    };
  
    const onChangePin = (e) => {
      setIsPin(e.target.checked)
    }

    const handleCustomQuestionChange = (event) => {
      setCustomQuestion(event.target.value);
      setQuestionError(false);
    };

    const handleEditModeToggle = () => {
      setIsEditMode(!isEditMode);
      setCustomQuestion('');
      setQuestionError(false);
    };

    const handleTagChange = (event) => {
      setTags(event.target.value); // Mettre à jour directement les tags
    };

    const handleSubmit = () => {
      isEditing ? dispatch(updateNotation({globalTarget, preciseTarget, exactTarget, customQuestion, isPin, displayDate, tags}, initial._id)) : dispatch(createNotation({globalTarget, preciseTarget, exactTarget, customQuestion, isPin, tags}, match))

      setGlobalTarget('')
      setPreciseTarget('')
      setExactTarget([])
      setCustomQuestion('')
      setTags([])

      onSubmit()
    }

    if(match.type==='actu')
    return (
      <div>
        {/*Discipline*/} 

        
        <Box sx={{marginBottom: 1, marginTop: 1}}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                marginBottom: 2,
                flexDirection: {
                  xs: 'column', // colonne en dessous de 650px
                  sm: 'row' // ligne à partir de 650px et plus large
                },
              }}
            >
              <Box>
                <Typography component="span" display="flex" alignItems="center" sx={{ paddingLeft: '2px' }}>
                  Date et heure
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DateTimePicker
                    value={displayDate ?? initial.creation}
                    onChange={onChangeDisplayDate}
                    inputFormat="dd/MM/yyyy HH:mm"
                    renderInput={(params) => <TextField {...params} fullWidth sx={{ maxWidth: 250 }} />}
                  />
                </LocalizationProvider>
              </Box>

              <Box>
              <FormControlLabel
                control={
                  <Checkbox checked={isPin} onChange={onChangePin} name="iPin" />
                }
                label={
                  <Typography component="span" display="flex" alignItems="center">
                    <PushPinIcon fontSize="small" style={{ marginRight: 4, color: 'black' }} />
                    Epingler la notation
                  </Typography>
                }
                sx={{
                  ml: { sm: 'auto', xs: 0 }, // Ajuste le margin selon la taille de l'écran
                  mt: { xs: 2, sm: 0 }, // Ajoute un espace au-dessus pour les petits écrans
                }}
              />

              {/* Select Multiple for Tags */}
              <MultiSelectTags match={match} tags={tags} handleTagChange={handleTagChange}/>
              </Box>
            </Box>
        </Box>

        <Box sx={{display : 'flex'}}>
        {isEditMode ? (
        <TextField
          id="custom-question"
          label="Question personnalisée"
          variant="standard"
          margin="normal"
          fullWidth
          multiline
          minRows={1}
          maxRows={2}
          value={customQuestion}
          onChange={handleCustomQuestionChange}
          error={questionError && !customQuestion}
          helperText={questionError && !customQuestion ? 'Veuillez saisir une question.' : ''}
        />
      ) : (
                <FormControl sx={{ m: 1 }} fullWidth>
                    <InputLabel id={"question"}>Question</InputLabel>
                    <Select 
                        labelId={'question'}
                        id={"question"}
                        name={'customQuestion'}
                        value={customQuestion}
                        label={'Question'}
                        onChange={(e) => setCustomQuestion(e.target.value)}
                    >
                        {notation_custoquestion_all && notation_custoquestion_all.map(i => (<MenuItem key={i._id} value={i._id}>{i.name ? i.name : `${i.lastname} ${i.firstname}`}</MenuItem>))}
                    </Select>
                </FormControl>
      )}
            <IconButton onClick={handleEditModeToggle}>
              <EditIcon />
            </IconButton>
        </Box>

        
        <br/>
                

                {customQuestion && <Button onClick={handleSubmit}>{isEditing ? "Modifier" : "Enregistrer"} la notation</Button>}
      </div>
    )


   
    return (
        <div>
        <FormControl>
            <FormLabel id="demo-controlled-radio-buttons-group">Que doit-on noter ?</FormLabel>
            <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={globalTarget}
            onChange={(e) => {setGlobalTarget(e.target.value); setPreciseTarget('team'); setExactTarget([])}}
            >
                <Grid>
                    <FormControlLabel value={'match'} control={<Radio />} label={'Match'} />
                    <FormControlLabel value={match.homeTeam._id} control={<Radio />} label={match.homeTeam.name} />
                    <FormControlLabel value={match.awayTeam._id} control={<Radio />} label={match.awayTeam.name} />
                </Grid>
            </RadioGroup>
        </FormControl>
        <Divider variant="inset" />
        {globalTarget && globalTarget!=='match' && <FormControl>
            <FormLabel id="demo-controlled-radio-buttons-group">Plus précisément ?</FormLabel>
            <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={preciseTarget}
            onChange={(e) => {setPreciseTarget(e.target.value); setExactTarget([])}}
            >
                <Grid>
                    <FormControlLabel value={'team'} control={<Radio />} label={'Equipe'} />
                    <FormControlLabel value={'players'} control={<Radio />} label={'Joueur(s)'} />
                    <br/>
                    {preciseTarget === 'players' && 
                        <FormControl sx={{ m: 1}} fullWidth>
                        <InputLabel id="demo-multiple-chip-label">Joueurs</InputLabel>
                        <Select
                          labelId="demo-multiple-chip-label"
                          id="demo-multiple-chip"
                          multiple
                          value={exactTarget}
                          onChange={(event) => {
                            const {
                              target: { value },
                            } = event;
                            setExactTarget(
                              // On autofill we get a stringified value.
                              typeof value === 'string' ? value.split(',') : value,
                            );
                          }}
                          input={<OutlinedInput id="select-multiple-chip" label="Joueurs" />}
                          renderValue={(selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                              {selected.map((value) => (
                                <Chip key={value} label={targetList().find(p => p._id === value).lastname} />
                              ))}
                            </Box>
                          )}
                          MenuProps={MenuProps}
                        >
                          {targetList().map(player => (
                            <MenuItem
                              key={player._id}
                              value={player._id}
                              style={getStyles(player._id, exactTarget, theme)}
                            >
                              {player.lastname}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      
                        }
                        
                </Grid>
            </RadioGroup>
        </FormControl>}

        

        <br/>

        <FormControlLabel
          control={
              <Checkbox
              checked={isPin}
              onChange={onChangePin}
              name="iPin"
              />
          }
          label="Epingler"
        />
        <br/>

        {isValidForm() && <Button onClick={handleSubmit}>{isEditing ? "Modifier" : "Enregistrer"} la notation</Button>}
        
        </div>


    )

}

export default LiveNotation